import Modal from '../modal';
export function file2Obj(file) {
    return Object.assign(Object.assign({}, file), { lastModified: file.lastModified, lastModifiedDate: file.lastModifiedDate, name: file.name, size: file.size, type: file.type, uid: file.uid, percent: 0, originFileObj: file });
}
/** Upload fileList. Replace file if exist or just push into it. */
export function updateFileList(file, fileList) {
    const nextFileList = [...fileList];
    const fileIndex = nextFileList.findIndex(({ uid }) => uid === file.uid);
    if (fileIndex === -1) {
        nextFileList.push(file);
    }
    else {
        nextFileList[fileIndex] = file;
    }
    return nextFileList;
}
export function getFileItem(file, fileList) {
    const matchKey = file.uid !== undefined ? 'uid' : 'name';
    return fileList.filter(item => item[matchKey] === file[matchKey])[0];
}
export function removeFileItem(file, fileList) {
    const matchKey = file.uid !== undefined ? 'uid' : 'name';
    const removed = fileList.filter(item => item[matchKey] !== file[matchKey]);
    if (removed.length === fileList.length) {
        return null;
    }
    return removed;
}
// ==================== Default Image Preview ====================
const extname = (url = '') => {
    const temp = url.split('/');
    const filename = temp[temp.length - 1];
    const filenameWithoutSuffix = filename.split(/#|\?/)[0];
    return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
};
const isImageFileType = (type) => type.indexOf('image/') === 0;
export const isImageUrl = (file) => {
    if (file.type && !file.thumbUrl) {
        return isImageFileType(file.type);
    }
    const url = (file.thumbUrl || file.url || '');
    const extension = extname(url);
    if (/^data:image\//.test(url) ||
        /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
        return true;
    }
    if (/^data:/.test(url)) {
        // other file types of base64
        return false;
    }
    if (extension) {
        // other file types which have extension
        return false;
    }
    return true;
};
const MEASURE_SIZE = 200;
export function previewImage(file) {
    return new Promise(resolve => {
        if (!file.type || !isImageFileType(file.type)) {
            resolve('');
            return;
        }
        const canvas = document.createElement('canvas');
        canvas.width = MEASURE_SIZE;
        canvas.height = MEASURE_SIZE;
        canvas.style.cssText = `position: fixed; left: 0; top: 0; width: ${MEASURE_SIZE}px; height: ${MEASURE_SIZE}px; z-index: 9999; display: none;`;
        document.body.appendChild(canvas);
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.onload = () => {
            const { width, height } = img;
            let drawWidth = MEASURE_SIZE;
            let drawHeight = MEASURE_SIZE;
            let offsetX = 0;
            let offsetY = 0;
            if (width > height) {
                drawHeight = height * (MEASURE_SIZE / width);
                offsetY = -(drawHeight - drawWidth) / 2;
            }
            else {
                drawWidth = width * (MEASURE_SIZE / height);
                offsetX = -(drawWidth - drawHeight) / 2;
            }
            ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            const dataURL = canvas.toDataURL();
            document.body.removeChild(canvas);
            resolve(dataURL);
        };
        img.src = window.URL.createObjectURL(file);
    });
}
// 合规配置下拦截点击和drop事件
export const interceptEventWithCompliance = (uploadDiv, type, isEN) => {
    // @ts-ignore
    const complianceConfig = window.Compliance_Config;
    let isLegal = !(complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadFileValid);
    const spanNode = uploadDiv === null || uploadDiv === void 0 ? void 0 : uploadDiv.querySelector('span[role="button"]');
    const inputNode = uploadDiv === null || uploadDiv === void 0 ? void 0 : uploadDiv.querySelector('input[type="file"]');
    const width = 495;
    spanNode === null || spanNode === void 0 ? void 0 : spanNode.addEventListener('click', e => {
        if ((complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadFileValid) && !isLegal) {
            e.preventDefault();
            e.stopPropagation();
            const modalInstance = Modal.confirm({
                width,
                title: isEN ? 'Operation confirmation' : '操作确认',
                content: complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadTipsContent,
                closable: true,
                okText: complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadConfirmButton,
                cancelText: complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadCancelButton,
                onOk() {
                    modalInstance.destroy();
                    isLegal = true;
                    spanNode === null || spanNode === void 0 ? void 0 : spanNode.click();
                    setTimeout(() => {
                        isLegal = !(complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadFileValid);
                    }, 100);
                },
            });
        }
    });
    if (type === 'drag') {
        spanNode === null || spanNode === void 0 ? void 0 : spanNode.addEventListener('drop', e => {
            var _a, _b;
            if ((complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadFileValid) && !isLegal) {
                e.preventDefault();
                e.stopPropagation();
                // 创建DataTransfer对象
                const dataTransfer = new DataTransfer();
                // 添加文件到DataTransfer
                Array.from((_b = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) !== null && _b !== void 0 ? _b : []).forEach(file => {
                    dataTransfer.items.add(file);
                });
                // 创建drop事件
                const dropEvent = new DragEvent('drop', {
                    bubbles: true,
                    cancelable: true,
                    dataTransfer,
                });
                const modalInstance = Modal.confirm({
                    width,
                    title: isEN ? 'Operation confirmation' : '操作确认',
                    content: complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadTipsContent,
                    closable: true,
                    okText: complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadConfirmButton,
                    cancelText: complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadCancelButton,
                    onOk() {
                        modalInstance.destroy();
                        isLegal = true;
                        inputNode === null || inputNode === void 0 ? void 0 : inputNode.dispatchEvent(dropEvent);
                        setTimeout(() => {
                            isLegal = !(complianceConfig === null || complianceConfig === void 0 ? void 0 : complianceConfig.uploadFileValid);
                        }, 100);
                    },
                });
            }
        });
    }
};
